export enum GeneralIntegrationStatusEnum {
  PENDING = 'PENDING',
  LOADING = 'LOADING',
  ACTIVE = 'ACTIVE',
  FAILED = 'FAILED',
}

export type GeneralIntegrationStatus = keyof typeof GeneralIntegrationStatusEnum;
